import type { ComponentProps } from "react";
import { cn } from "../../lib/utils";

/** Campo de formulário padrão — papel branco, hairline que escurece no focus. */
export function Input({ className, ...props }: ComponentProps<"input">) {
  return (
    <input
      className={cn(
        "h-11 w-full rounded-md border border-line bg-surface px-4 text-sm text-foreground " +
          "placeholder:text-subtle outline-none transition-all duration-200 " +
          "hover:border-[#c9c5b6] focus:border-accent focus:ring-4 focus:ring-accent/10",
        className,
      )}
      {...props}
    />
  );
}

export function Textarea({ className, ...props }: ComponentProps<"textarea">) {
  return (
    <textarea
      className={cn(
        "w-full resize-none rounded-md border border-line bg-surface px-4 py-3 text-sm text-foreground " +
          "placeholder:text-subtle outline-none transition-all duration-200 " +
          "hover:border-[#c9c5b6] focus:border-accent focus:ring-4 focus:ring-accent/10",
        className,
      )}
      {...props}
    />
  );
}

/** Rótulo de campo com a mesma cara em todo o formulário. */
export function Field({
  label,
  children,
  className,
}: {
  label: string;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <label className={cn("flex flex-col gap-2", className)}>
      <span className="text-[13px] font-medium text-foreground/80">{label}</span>
      {children}
    </label>
  );
}
